import { PasswordFormValues } from 'types/state';
import { usePasswordEditorState } from 'hooks/usePasswordEditorState';

export const usePasswordFormValues = (): PasswordFormValues => {
  const { formValues } = usePasswordEditorState();

  return formValues;
};
